
import useConverter from '@/composables/general/useConverter';
import { useRoute } from 'vue-router';
import useHashParams from '@/composables/general/useHashParams';
import { onActivated } from '@vue/runtime-core';
import SocialSharing from '@/components/general/WdwSocialSharing.vue';
import AdminLink from '@/components/general/AdminLink.vue';
import AttributeList from '@/components/discuss/thought/AttributeTags.vue';
import useThoughtHelpers from '@/composables/thought/useThoughtHelpers';
import useStringManip from '@/composables/general/useStringManip';

export default {
  name: 'SingleThought',
  components: {
    SocialSharing,
    AttributeList,
    AdminLink,
  },
  props: {
    thought: { type: Object, required: true },
  },
  setup(props: any, { emit }: any) {
    //REF
    const route = useRoute();
    const { getPlainText } = useStringManip();
    const { deleteHashParam } = useHashParams(route);
    const { formattedDate } = useConverter();
    const { getCurrenThoughtUri } = useThoughtHelpers();

    //METHODS
    function backToList() {
      deleteHashParam('thought_id');
    }

    //LIFEHOOKS
    onActivated(() => {
      emit('scrollIntoView');
    });

    return {
      getPlainText,
      //REF
      formattedDate,
      getCurrenThoughtUri,
      //METHODS
      backToList,
    };
  },
};
